import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'sd-bottom-sheet-body',
  templateUrl: './bottom-sheet-body.component.html',
  styleUrls: [
    '../../../assets/css/scrollbar.scss',
    './bottom-sheet-body.component.scss']
})
export class BottomSheetBodyComponent implements OnInit {
  @Input() height = 'auto';
  constructor() { }

  ngOnInit() {
  }
}
